type ValueOf<T extends readonly unknown[]> = T[number];

export const FIELD_SETS = ['basic', 'purchase', 'recruitment'] as const;
export type FieldSet = ValueOf<typeof FIELD_SETS>;

export const FIELD_SET_LABELS: Readonly<Record<FieldSet, string>> = Object.freeze({
  basic: 'Basic request',
  purchase: 'Purchase request',
  recruitment: 'Hire request',
});

export const FIELD_SET_DESCRIPTIONS: Readonly<Record<FieldSet, string>> = Object.freeze({
  basic: 'Title, description, priority, department and assignee.',
  purchase: 'Adds cost center, amount, currency and the date it is needed by.',
  recruitment: 'Adds the position, working language and the deadline.',
});

export const TICKET_STATUSES = ['open', 'on_hold', 'closed'] as const;
export type TicketStatus = ValueOf<typeof TICKET_STATUSES>;

export const TICKET_STATUS_LABELS: Readonly<Record<TicketStatus, string>> = Object.freeze({
  open: 'Open',
  on_hold: 'On hold',
  closed: 'Closed',
});

export const TICKET_PRIORITIES = ['low', 'normal', 'high'] as const;
export type TicketPriority = ValueOf<typeof TICKET_PRIORITIES>;

export const TICKET_PRIORITY_LABELS: Readonly<Record<TicketPriority, string>> = Object.freeze({
  low: '1 Low',
  normal: '2 Normal',
  high: '3 High',
});

export const COST_CENTERS = ['client', 'hq'] as const;
export type CostCenter = ValueOf<typeof COST_CENTERS>;

export const COST_CENTER_LABELS: Readonly<Record<CostCenter, string>> = Object.freeze({
  client: 'Client (billable)',
  hq: 'HQ (internal)',
});

export const CURRENCIES = ['EUR', 'USD', 'GBP', 'RSD'] as const;
export type Currency = ValueOf<typeof CURRENCIES>;

export const RECRUITMENT_LANGUAGES = [
  'English',
  'Serbian',
  'German',
  'French',
  'Italian',
  'Spanish',
  'Russian',
  'Mandarin Chinese',
  'Other',
] as const;
export type RecruitmentLanguage = ValueOf<typeof RECRUITMENT_LANGUAGES>;

export const EMPLOYMENT_TYPES = [
  'full_time',
  'part_time',
  'contractor',
  'internship',
  'temporary',
] as const;
export type EmploymentType = ValueOf<typeof EMPLOYMENT_TYPES>;

export const EMPLOYMENT_TYPE_LABELS: Readonly<Record<EmploymentType, string>> = Object.freeze({
  full_time: 'Full time',
  part_time: 'Part time',
  contractor: 'Contractor',
  internship: 'Internship',
  temporary: 'Temporary',
});

export const ACCESS_LEVELS = ['create', 'read', 'write', 'full'] as const;
export type AccessLevel = ValueOf<typeof ACCESS_LEVELS>;

export const ACCESS_LEVEL_LABELS: Readonly<Record<AccessLevel, string>> = Object.freeze({
  create: 'Can file requests',
  read: 'Can view queue',
  write: 'Can work on tickets',
  full: 'Full access (can be assignee)',
});

export const WORKING_ACCESS_LEVELS: readonly AccessLevel[] = Object.freeze([
  'read',
  'write',
  'full',
] as const);

export const ACCESS_OVERLAYS = ['admin', 'ceo', 'department_head'] as const;
export type AccessOverlay = ValueOf<typeof ACCESS_OVERLAYS>;

export const ACCESS_OVERLAY_LABELS: Readonly<Record<AccessOverlay, string>> = Object.freeze({
  admin: 'Admin',
  ceo: 'CEO',
  department_head: 'Department Head',
});
